import { ChatCommandEvent, MessageAction } from '../constants/enums'
import { FCTYPE_PMESG } from '../mfcLogic/mfcConstants'
import { pubSubChatCommands } from '../state/pubSub'
import { setPMChatWasPMCommandUsedState } from '../state/state.pm'
import i18n from '../utilities/i18n'
import { loadUserIfNeeded } from './loadUserIfNeeded'
import { openError } from './openError'
import { messageAction } from './workerActions'

export const sendPrivateMessage = async (
    id: number,
    message = '',
    pmCommand?: boolean,
) => {
    if (message.trim().length === 0) return
    const user = await loadUserIfNeeded(id)
    if (!user) {
        openError({
            message: i18n.t('chat.pmWithoutValidUsername'),
        })
        return
    }

    if (pmCommand !== undefined) {
        setPMChatWasPMCommandUsedState(id, pmCommand)
    }

    if (message.startsWith('/')) {
        const payload = {
            message,
            user,
            chatType: FCTYPE_PMESG,
        }
        pubSubChatCommands.emit(ChatCommandEvent.GENERATE_COMMANDS, payload)
    } else {
        messageAction(MessageAction.SEND_MESSAGE, { id: user.id, message })
    }
}
